import { ProductCardPrice } from '../../../../product';
import { ProductCardPriceProps } from '../../../../product/types';
import styles from '../../../serviceRecommendation.module.scss';


export const ServiceRecommendationPartTotalPrice = ({ price, currency }: ProductCardPriceProps) => {

    return (
        <div className={styles['total-price-wrapper']}>
            <ProductCardPrice price={price} currency={currency} />
        </div>
    )
}